
import * as clock from "./clock.js";
import * as utc from "./utc.js";

/**
 * @param {string} time_cursor ISO string or "now" special keyword
 * @returns {object} date parts, with "now" resolved to the current clock's time
 */
export function resolveTimeCursor(time_cursor) {
    return utc.parts(time_cursor === "now" ? clock.now() : time_cursor);
}
